/**
 * Subscription reducer and actions
 * @module reducers/subscription
 */

// Action constant
export const SUBSCRIPTION_ACTION = 'SUBSCRIPTION_ACTION';

// Action creator
export function subscriptionAction(action: string) {
  return {
    type: SUBSCRIPTION_ACTION,
    request: {
      op: 'post',
      path: `/@subscription/${action}`,
    },
  };
}

// State interface
interface SubscriptionState {
  error: any;
  loaded: boolean;
  loading: boolean;
  result: any;
}

// Initial state
const initialState: SubscriptionState = {
  error: null,
  loaded: false,
  loading: false,
  result: null,
};

// Reducer
export default function subscription(
  state: SubscriptionState = initialState,
  action: any = {}
): SubscriptionState {
  switch (action.type) {
    case `${SUBSCRIPTION_ACTION}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${SUBSCRIPTION_ACTION}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        result: action.result,
      };
    case `${SUBSCRIPTION_ACTION}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}

